import _ from 'lodash'

export type Resolvable<T = any, TArgs extends ReadonlyArray<any> = []> = T | ((...args: TArgs) => T)
export type Resolved<T> = T extends AnyFn ? ReturnType<T> : T

export function resolveValue<T, TArgs extends ReadonlyArray<any>>(val: Resolvable<T, TArgs>, ...args: TArgs): T {
    return _.isFunction(val) ? val(...args) : val
}
